import { createRouter, createMemoryHistory, Router } from 'vue-router'

import Login from './Login/Login.vue'
import Favorites from './Favorites/Favorites.vue'
import Feedbacks from './Feedbacks/Feedbacks.vue'
import Home from './Home/Home.vue'
import Knowledge from './Home/Knowledge.vue'
import Collection from './Home/Collection.vue'
import Content from './Home/Content.vue'
import Notifications from './Notifications/Notifications.vue'
import Settings from './Settings/Settings.vue'
import Error from './Error.vue'
import Copilot from './Copilot/Copilot.vue'

import handleRouteLang from '@commons/middlewares/handleRouteLang'
import { applyMiddlewares } from './utils'

const routes = [
  {
    name: 'login',
    path: '/login',
    component: Login
  },
  {
    name: 'index',
    path: '/',
    component: Home,
    meta: { tabIndex: 0, authorize: ['LoggedIn'] },
    children: [
      {
        path: '/:lang?/knowledges/:knowledgeId',
        name: 'knowledge-viewer',
        component: Knowledge,
        meta: { tabIndex: 0, authorize: ['LoggedIn'], lang: true }
      },
      {
        path: '/:lang?/cases/:id',
        name: 'collection-viewer',
        component: Collection,
        meta: { tabIndex: 0, authorize: ['LoggedIn'], lang: true }
      }
    ]
  },
  {
    path: '/:lang?/contents/:id',
    name: 'content-viewer',
    component: Content,
    meta: { tabIndex: 0, authorize: ['LoggedIn'], lang: true }
  },
  {
    name: 'copilot',
    path: '/copilot',
    component: Copilot,
    meta: {
      authorize: ['LoggedIn'],
      tabIndex: 1
    }
  },
  {
    name: 'favorites',
    path: '/favorites',
    component: Favorites,
    meta: { tabIndex: 2, authorize: ['LoggedIn'] }
  },
  {
    name: 'notifications',
    path: '/notifications',
    component: Notifications,
    meta: { tabIndex: 3, authorize: ['LoggedIn'] }
  },
  {
    name: 'feedbacks',
    path: '/feedbacks',
    component: Feedbacks,
    meta: { tabIndex: 4, authorize: ['LoggedIn'] }
  },
  {
    name: 'settings',
    path: '/settings',
    component: Settings,
    meta: { tabIndex: 5, authorize: ['LoggedIn'] }
  },
  {
    path: '/:catchAll(.*)',
    component: Error
  }
]

export default function (): Router {
  const router = createRouter({
    history: createMemoryHistory(), // To debug use createWebHashHistory(),
    routes
  })

  router.beforeEach(
    applyMiddlewares([
      pageTransition,
      isAuthenticated,
      homeTabRedirections,
      lastEntityRouteHandler,
      handleRouteLang,
      fetchKnowledgeData,
      fetchContentMainData,
      fetchContentModalData
    ])
  )

  return router
}
